import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HygraphService } from '@app/@shared/services/hygraph/hygraph.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
@UntilDestroy()
@Component({
    selector: 'app-hygraph-preview-redirect',
    imports: [],
    template: ''
})
export class HygraphPreviewRedirectComponent implements OnInit {

  constructor(
    private readonly hygraphService: HygraphService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.pipe(
      concatMap((params) => {
        if (!params.has('hygraphId')) {
          return of(this.router.createUrlTree(['/404']));
        } else {
          return this.hygraphService.getContentIdFromHygraphId(params.get('hygraphId')).pipe(
            map(contentId => contentId
              ? this.router.createUrlTree(['/sectioned-blog-viewer', contentId], { queryParams: { stage: 'PREVIEW' } })
              : this.router.createUrlTree(['/404'])
            ),
            catchError(() => of(this.router.createUrlTree(['/404'])))
          )
        }
      }),
      untilDestroyed(this)
    ).subscribe((urlTree) => {
      this.router.navigateByUrl(urlTree);
    });
  }
}
